import React, { ReactNode, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Container } from 'react-bootstrap';
import LoadingOverlay from '../common/LoadingOverlay/LoadingOverlay';

interface AuthLoadingWrapperProps {
  children: ReactNode;
}

const AuthLoadingWrapper: React.FC<AuthLoadingWrapperProps> = ({ children }) => {
  const { isLoading, error } = useAuth0();

  // Debug: Log every render and state
  console.log('[AuthLoadingWrapper] Rendered', { isLoading, error });

  // Log any errors to console for debugging
  useEffect(() => {
    if (error) {
      console.error('[AuthLoadingWrapper] Auth0 Error:', error);
    }
  }, [error]);

  // Show loading during authentication
  if (isLoading) {
    return (
      <Container>
        <LoadingOverlay />
      </Container>
    );
  }

  // If there's an error, log it but still try to render children
  // This allows the app to function even if there's a non-critical Auth0 error
  if (error) {
    console.warn('[AuthLoadingWrapper] Auth0 error detected, but rendering children anyway:', error);
  }

  // Route-level guards handle redirects; this wrapper should not force global navigation.
  return <>{children}</>;
};

export default AuthLoadingWrapper;
